{
  "email-phone-confirmation-pin-dialog": {
    "buttons": {
      "resend": "Renvoyer",
      "submit": "Soumettre"
    },
    "text": {
      "email-confirmation": "Confirmation par e-mail",
      "enter-to-confirm-email": "Veuillez saisir le code PIN pour confirmer votre e-mail",
      "enter-to-confirm-phone": "Veuillez saisir le code PIN pour confirmer votre numéro de téléphone",
      "in-second": "en {{seconds}} s",
      "phone-confirmation": "Confirmation du numéro de téléphone",
      "pin-sent-to-email": "Le code PIN est envoyé à votre e-mail",
      "pin-sent-to-phone": "Le code PIN est envoyé à votre numéro de téléphone",
      "update-success": "Mise à jour réussie !"
    }
  }
}
